// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"bec5ec3c","229":"b9fa67f5","399":"a708bb30","417":"8bd01c4e","453":"fbf106e0","506":"714ccbfb","583":"9869b98f","845":"da1f1e40","996":"73679a7e"}[chunkId] + ".chunk.js";
};